// Team data and logo utilities
const teamDataCache = {};

const getLeagueConfig = (league) => {
  if (league === 'nfl') {
    return {
      sportPath: 'football/nfl',
      // ESPN uses displayName like "Atlanta Falcons"
      transformTeam: (team) => ({
        id: team.id,
        displayName: team.displayName,
        abbreviation: team.abbreviation,
        shortDisplayName: team.shortDisplayName,
        logo: team.logos?.[0]?.href || null,
        color: team.color,
        alternateColor: team.alternateColor
      })
    };
  }

  // Default to NBA configuration
  return {
    sportPath: 'basketball/nba',
    transformTeam: (team) => ({
      id: team.id,
      displayName: team.displayName,
      abbreviation: team.abbreviation,
      shortDisplayName: team.shortDisplayName,
      logo: team.logos?.[0]?.href || null,
      color: team.color,
      alternateColor: team.alternateColor
    })
  };
};

export const fetchTeamData = async (league = 'nba') => {
  if (teamDataCache[league]) {
    return teamDataCache[league];
  }

  const { sportPath, transformTeam } = getLeagueConfig(league);

  try {
    const response = await fetch(`https://site.api.espn.com/apis/site/v2/sports/${sportPath}/teams`);
    const data = await response.json();

    if (!data?.sports?.[0]?.leagues?.[0]?.teams) {
      throw new Error(`Unexpected team response for ${league}`);
    }

    const teams = data.sports[0].leagues[0].teams.map(teamWrapper => transformTeam(teamWrapper.team));

    const teamMap = {};
    teams.forEach(team => {
      if (team.displayName) {
        teamMap[team.displayName] = team;
      }
    });

    teamDataCache[league] = teamMap;
    return teamMap;
  } catch (error) {
    console.error(`Error fetching ${league.toUpperCase()} team data:`, error);
    teamDataCache[league] = {};
    return {};
  }
};

export const getTeamLogo = (teamName, teamData) => {
  if (!teamData || !teamData[teamName]) {
    return null;
  }
  return teamData[teamName].logo;
};

export const parseGameTeams = (gameTitle) => {
  // Parse "Team A @ Team B" format
  const parts = gameTitle.split(' @ ');
  if (parts.length === 2) {
    return {
      awayTeam: parts[0].trim(),
      homeTeam: parts[1].trim()
    };
  }
  return { awayTeam: null, homeTeam: null };
};
